module.exports = __webpack_public_path__ + "static/ForBackgroundVideo-94ac961ab89d93c58e38fb48ea28799e.mp4";